import axios from 'axios'
import { createStore } from 'vuex'
import _ from 'lodash'

export default createStore({

  state: {
    // sourceUrl: 'https://quiz-metiers.local:50115/',
    // sourceUrl: 'https://cdm-admin.bart-studio.ch',
    sourceUrl: process.env.VUE_APP_API_URL,
    // quiz details
    details: [],
    // metiers
    jobs: [],
    // questions
    questions: [],
    // results
    userResponses: [],
    // side image
    // image: ''
    results: [],
    // selection du pays
    selectedCountry: 'ch', // 'ch' ou 'fr'
  },
  mutations: {
    SET_DETAILS (state, details) {
      state.details = details
    },
    SET_QUESTIONS (state, questions) {
      state.questions = questions
    },
    SET_JOBS (state, jobs) {
      state.jobs = jobs
    },
    SET_COUNTRY (state, country) {
      state.selectedCountry = country
    }
  },
  actions: {
    getDetails ({ commit }) {
      axios
        .get(this.state.sourceUrl + '/wp-json/quiz/v2/details',
          {
            auth: {
              username: process.env.VUE_APP_API_USERNAME,
              password: process.env.VUE_APP_API_PASSWORD
            }
          }
        )
        .then(response => {
          commit('SET_DETAILS', response.data)
          console.log('Details recieved')
          // console.log(this.details)
        })
        .catch(error => {
          console.log('Bad news with the datas')
          console.log(this.state.sourceUrl + '/wp-json/quiz/v2/details')
          console.log(error)
        })
    },
    getQuestions ({ commit }) {
      axios
        .get(this.state.sourceUrl + '/wp-json/quiz/v2/questions',
          {
            auth: {
              username: process.env.VUE_APP_API_USERNAME,
              password: process.env.VUE_APP_API_PASSWORD
            }
          }
        )
        .then(response => {
          commit('SET_QUESTIONS', response.data)
          console.log('Questions recieved')
          console.log(this.questions)
        })
        .catch(error => {
          console.log('Bad news with the questions')
          console.log(error)
        })
    },
    getJobs ({ commit }) {
      axios
        .get(this.state.sourceUrl + '/wp-json/quiz/v2/metiers',
          {
            auth: {
              username: process.env.VUE_APP_API_USERNAME,
              password: process.env.VUE_APP_API_PASSWORD
            }
          }
        )
        .then(response => {
          commit('SET_JOBS', response.data)
          console.log('Jobs recieved')
          // console.log(this.jobs)
        })
        .catch(error => {
          console.log('Bad news with the jobs')
          console.log(error)
        })
    },
    theResults_old () {
      let i = 0
      while (i < this.state.jobs.length) {
        // récupère les questions correspondantes pour le métier
        const validAnswers = Object.values(this.state.jobs[i].questions).map(Number)
        if (validAnswers.length > 0) {
          // les réponses de l'utilisateur
          const userReponsesArr = this.state.userResponses
          console.log('nbre-loop:' + this.state.jobs.length)
          console.log(i)
          console.log('validAnswers' + validAnswers)
          console.log('userReponsesArr' + userReponsesArr)
          // les réponses de l'utilisateur
          const isCorresponding = validAnswers.every(function (value) {
            if (value) {
              return userReponsesArr.includes(value)
            }
          })
          if (isCorresponding === true) {
            this.state.results.push(i)
            console.log('results' + this.state.results)
          }
        }
        i++
        // return this.value
        // pour chaque job dans jobs
        // si toutes les valeurs de job.questions sont dans userResponses
        // this.results[].push(job.index)
      }
      if (this.state.results) {
        return true
      }
    },
    theResults () {
      // pourcentages
      // pour chaque job dans jobs
      // compter toutes les valeurs commune entre userResponses et validanswers
      // compter le nombre de reponses valide
      // générer le pourcentage de bonne reponses
      // si le pourcentage > 75% = créer une entrée dans le tableau results
      // sinon prendre les 10 meilleurs métiers
      this.state.results = []
      let resultsPercentage = 85
      const userReponsesArr = this.state.userResponses
      let allResults = [] // Stocker tous les résultats pour le fallback
      
      // pour chaque job
      this.state.jobs.forEach((job, i) => {
        const jobValidAnswers = Object.values(job.questions).map(Number)
        const jobMandatoryAnswers = Object.values(job.mandatory_questions).map(Number)

        if (jobValidAnswers.length > 0) {
          const jobTotalAnswers = jobValidAnswers.length
          const jobResults = _.intersection(jobValidAnswers, userReponsesArr).length

          let jobPercentage = jobResults / jobTotalAnswers * 100
          jobPercentage = Math.round(jobPercentage)
          
          const jobResult = { 
            jobIndex: i, 
            percentage: jobPercentage, 
            jobSlug: this.state.jobs[i].slug, 
            jobCategory: this.state.jobs[i].category_name, 
            jobCategorySlug: this.state.jobs[i].category_slug 
          }

          // Ajouter à tous les résultats
          allResults.push(jobResult)

          // Vérifier si le métier respecte le seuil de 85%
          if (jobPercentage >= resultsPercentage && jobMandatoryAnswers.length === 0) {
            this.state.results.push(jobResult)
          } else if (jobPercentage >= resultsPercentage && jobMandatoryAnswers.length > 0 && _.intersection(jobMandatoryAnswers, userReponsesArr).length === jobMandatoryAnswers.length) {
            this.state.results.push(jobResult)
          }
        }
      })

      // Si moins de 10 résultats avec le seuil de 85%, prendre les 10 meilleurs
      if (this.state.results.length < 10) {
        console.log(`Seulement ${this.state.results.length} métiers trouvés avec ${resultsPercentage}%, récupération des 10 meilleurs`)
        
        // Trier tous les résultats par pourcentage décroissant
        allResults = _.orderBy(allResults, ['percentage'], ['desc'])
        
        // Filtrer pour les questions obligatoires si nécessaire
        allResults = allResults.filter(result => {
          const job = this.state.jobs[result.jobIndex]
          const jobMandatoryAnswers = Object.values(job.mandatory_questions).map(Number)
          
          if (jobMandatoryAnswers.length === 0) {
            return true // Pas de questions obligatoires
          } else {
            // Vérifier que toutes les questions obligatoires sont cochées
            return _.intersection(jobMandatoryAnswers, userReponsesArr).length === jobMandatoryAnswers.length
          }
        })
        
        // Prendre les 10 premiers (meilleurs pourcentages)
        this.state.results = allResults.slice(0, 10)
      }

      // NOUVEAU : Trier les résultats finaux par pourcentage décroissant puis par ordre alphabétique
      this.state.results = this.state.results.sort((a, b) => {
        // D'abord par pourcentage (décroissant)
        if (b.percentage !== a.percentage) {
          return b.percentage - a.percentage
        }
        
        // En cas d'égalité, par ordre alphabétique du nom du métier
        const jobA = this.state.jobs[a.jobIndex]
        const jobB = this.state.jobs[b.jobIndex]
        
        // Utiliser le nom français si disponible, sinon le nom par défaut
        const nameA = (this.state.selectedCountry === 'fr' && jobA.metier_fr) ? jobA.metier_fr : jobA.metier
        const nameB = (this.state.selectedCountry === 'fr' && jobB.metier_fr) ? jobB.metier_fr : jobB.metier
        
        return nameA.localeCompare(nameB, 'fr', { sensitivity: 'base' })
      })

      console.log('results (triés par % puis alphabétique)')
      console.log(this.state.results)
      console.log(`${this.state.results.length} métiers affichés`)
      
      return true
    }
  },
  getters: {
  },
  modules: {
  }
})
